import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { AudioManager, SoundTrack } from "../../AudioManager";
import { SplashState } from "./SplashState";

export class GameTitle extends Phaser.Group {

    private static soundtrackActivated: boolean = false;
    
    private foot: Phaser.Image;
    private chinko: Phaser.Image;
    private trophies: Phaser.Image;
    private trophiesWithBlending: Phaser.Image;
    private whiteTrophies: Phaser.Image;

    constructor(game: Phaser.Game) {

        super(game, null, "game-title", false);

        this.y = 150;

        this.scale.y = GameVars.scaleY;

        const glowBackground = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, 15, "texture_atlas_2", "splash_glow");
        glowBackground.anchor.set(.5);
        this.add(glowBackground); 

        this.trophies = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, 0, "texture_atlas_2", "title_trophies");
        this.trophies.anchor.set(.5);
        this.trophies.visible = false;
        this.add(this.trophies);

        this.trophiesWithBlending = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, 0, "texture_atlas_2", "title_trophies");
        this.trophiesWithBlending.anchor.set(.5);
        this.trophiesWithBlending.visible = false;
        this.add(this.trophiesWithBlending);

        this.whiteTrophies = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, 0, "texture_atlas_2", "title_trophies_white");
        this.whiteTrophies.anchor.setTo(.5);
        this.whiteTrophies.visible = false;
        this.add(this.whiteTrophies);

        this.foot = new Phaser.Image(this.game, -420, -10, "texture_atlas_2", "foot");
        this.foot.anchor.set(.5);
        this.add(this.foot);

        this.chinko = new Phaser.Image(this.game, 1050, 100, "texture_atlas_2", "chinko");
        this.chinko.anchor.setTo(.5);
        this.add(this.chinko);
    }

    public startAnimation(): void {

        this.game.add.tween(this.foot).to({x: GameConstants.GAME_WIDTH / 2}, 650,  Phaser.Easing.Bounce.Out, true, 1700);
        this.game.add.tween(this.chinko).to({x: GameConstants.GAME_WIDTH / 2}, 650,  Phaser.Easing.Bounce.Out, true, 1700)
            .onComplete.add(this.showTrophies, this);

        this.game.time.events.add(1850, this.startSoundtrack, this);
    }

    private startSoundtrack(): void {

        if (!GameTitle.soundtrackActivated) {
            GameTitle.soundtrackActivated = true;
            AudioManager.getInstance().playMusic(SoundTrack.MENUS);
        }
    }

    private showTrophies(): void {

        this.whiteTrophies.visible = true;
        this.whiteTrophies.alpha = .5;
        this.whiteTrophies.scale.set(0);

        this.trophiesWithBlending.visible = true;
        this.trophiesWithBlending.blendMode = 3;
        this.trophiesWithBlending.scale.set(0);

        this.game.add.tween( this.trophiesWithBlending.scale).to({x: 1, y: 1}, 650, Phaser.Easing.Quadratic.Out, true, 650)
            .onComplete.add(this.onWhiteTrophiesAnimationFinished, this);

        this.game.add.tween( this.whiteTrophies.scale).to({x: 1, y: 1}, 500, Phaser.Easing.Quadratic.Out, true, 650);
    }

    private onWhiteTrophiesAnimationFinished(): void {

        this.game.add.tween(this.whiteTrophies).to({alpha: 0}, 250, Phaser.Easing.Quadratic.In, true)
            .onComplete.add(this.onAnimationFinished, this);
    }

    private onAnimationFinished(): void {

        this.whiteTrophies.destroy();

        this.trophies.visible = true;

        this.game.add.tween(this.trophiesWithBlending).to({alpha: 0}, 500, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(function(): void {
                this.trophiesWithBlending.destroy();
            }, this);
        
        SplashState.currentInstance.showButtons();    
    }
}
